import classNames from 'clsx'
import { bool, string } from 'prop-types'
import { useSelector } from 'react-redux'

import { getOrderDocuments } from 'shared/store-checkout/duck/orderDraft'
import ProductImage from 'views/components/organisms/ProductImage'
import './SubOrderProductImages.scss'

const SubOrderProductImages = ({ subOrderId, forceLeft, flexAndwrap }) => {
  const orderDocuments = useSelector(state =>
    getOrderDocuments(state, subOrderId)
  )
  const listClassNames = classNames(
    'o-SubOrderProductImages a-list-reset l-flex',
    { 'l-flex--justify-content--end@medium': !forceLeft },
    { ' l-flex--nowrap': !flexAndwrap },
    { ' l-flex--wrap': flexAndwrap }
  )
  return (
    <ul className={listClassNames}>
      {orderDocuments.map(orderDocument => {
        const { documentPositions } = orderDocument

        return documentPositions.map((document, index) => {
          const { thumbnailURL, itemName: name } = document
          return (
            <li
              className="o-SubOrderProductImages__item"
              key={`arlp-${subOrderId}-${name}-${index}`}
            >
              <ProductImage
                thumbnail
                imageUrl={thumbnailURL}
                name={name}
                srcWidth={60}
                srcHeight={60}
                tighterThumbnailWithDarkBackground
              />
            </li>
          )
        })
      })}
    </ul>
  )
}
SubOrderProductImages.propTypes = {
  subOrderId: string.isRequired,
  forceLeft: bool,
  flexAndwrap: bool,
}

SubOrderProductImages.defaultProps = {
  forceLeft: false,
  flexAndwrap: false,
}

export default SubOrderProductImages
